<template>
  <v-form>
    <v-select
      v-model="project"
      :items="projects"
      item-text="label"
      item-value="key"
      :label="getLabel('project')"
      :error="!project && errors.length > 0"
      @change="permissionType = null"
    />
    <v-select
      v-model="restrictionType"
      :items="restrictionToShow"
      :disabled="project === null"
      item-text="label"
      item-value="key"
      :label="getLabel('permission')"
      :error="!restrictionType && errors.length > 0"
    />
    <v-btn color="success" outlined @click="nextStep">
      {{ getLabel("continue") }}
      <v-icon class="ml-2">mdi-arrow-right</v-icon>
    </v-btn>
  </v-form>
</template>

<script>

import { ref, computed } from '@vue/composition-api';

import { getLabel } from '@/utils/index';

export default {
  props: {
    restriction: {
      type: Object,
      required: true
    }
  },
  setup (props, { emit }) {
    const errors = ref([]);

    const project = ref(props.restriction.project || null);

    const restrictionType = ref(props.restriction.type || null);

    const projects = [{ key: 'alpha', label: 'Alpha' }, { key: 'speedboat', label: 'Speedboat' }];

    const restrictionsTypes = { common: ['show_only_content_types', 'restrict_content_types', 'show_only_contents', 'hide_contents'], alpha: ['show_calendar'] };

    const restrictionToShow = computed(() => {
      if (project.value) {
        const projectPermissions = restrictionsTypes[project.value] || [];
        return [...restrictionsTypes.common, ...projectPermissions].map(p => ({ key: p, label: getLabel(p) }));
      }
      return [];
    });

    const nextStep = () => {
      if (!project.value || !restrictionType.value) {
        errors.value = ['Insert a project and a permission type'];
        emit('showErrors', errors.value);
        return;
      }
      errors.value = [];
      emit('updateRestriction', { ...props.restriction, project: project.value, type: restrictionType.value });
    };

    return { getLabel, errors, project, restrictionType, projects, restrictionToShow, nextStep };
  }

};
</script>
